import { fromJS } from 'immutable';
import config from '../../../config';
import actions from '../../constants/portal/records';
import {checkJsonResponse, logErrorConsole} from 'utils/actions';

export const recordIsLoading = (data) => ({
  type: actions.RECORD_IS_LOADING,
  data
});

export const loadReception = (id) => (dispatch) => {
  fetch(`${config.apiHost}/reception/?staff=${id}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json.results);
    dispatch({
      type: actions.LOAD_RECEPTION,
      data
    });
  })
  .catch(logErrorConsole)
};


export const submitRecord = (reception, user) => (dispatch, getState) => {
  dispatch(recordIsLoading(true));
  const options = {
    method : "post",
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
      "Content-type": 'application/json'
    },
    body: JSON.stringify({
      reception: reception,
      user: user
    })
  }
  fetch(`${config.apiHost}/record/`, options)
  .then(checkJsonResponse)
  .then((json) => {
    dispatch(recordIsLoading(false));
    dispatch({
      type: actions.LOAD_CURRENT_RECORD,
      data: fromJS(json)
    })
  })
  .catch(logErrorConsole)
};


export const loadRecords = (id, limit, offset) => (dispatch, getState) => {
  dispatch(recordIsLoading(true));
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  fetch(`${config.apiHost}/record/?staff=${id}&limit=${limit}&offset=${offset}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    dispatch(recordIsLoading(false))
    dispatch({
      type: actions.LOAD_RECORDS,
      data: fromJS(json)
    })
  })
  .catch(logErrorConsole)
};



export const searchRecords = (start, end, staff_id, status, institution='', user="", limit, offset) => (dispatch, getState) => {
  const date_created_start = start.format("YYYY-MM-DD");
  const date_created_end = end.format("YYYY-MM-DD");
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  dispatch(recordIsLoading(true));
  fetch(`${config.apiHost}/record/?date_record_0=${date_created_start}&date_record_1=${date_created_end}&staff=${staff_id}&status=${status}&administration=${institution}&user=${user}&limit=${limit}&offset=${offset}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    dispatch(recordIsLoading(false))
    dispatch({
      type: actions.LOAD_RECORDS,
      data: fromJS(json)
    })
  })
  .catch(logErrorConsole)
};


export const searchRegistryRecords = (start, end, staff_id, status, administration, institution='', limit, offset) => (dispatch, getState) => {
  const date_created_start = start.format("YYYY-MM-DD");
  const date_created_end = end.format("YYYY-MM-DD");
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  dispatch(recordIsLoading(true));
  fetch(`${config.apiHost}/record/?date_record_0=${date_created_start}&date_record_1=${date_created_end}&staff=${staff_id}&status=${status}&administration=${administration}&institution=${institution}&limit=${limit}&offset=${offset}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    dispatch(recordIsLoading(false))
    dispatch({
      type: actions.LOAD_RECORDS,
      data: fromJS(json)
    })
  })
  .catch(logErrorConsole)
};

export const searchRegistryRecordsByInstitution = (start, end, staff_id, status, institution='', limit, offset) => (dispatch, getState) => {
  const date_created_start = start.format("YYYY-MM-DD");
  const date_created_end = end.format("YYYY-MM-DD");
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  dispatch(recordIsLoading(true));
  fetch(`${config.apiHost}/record/?date_record_0=${date_created_start}&date_record_1=${date_created_end}&staff=${staff_id}&status=${status}&institution=${institution}&limit=${limit}&offset=${offset}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    dispatch(recordIsLoading(false))
    dispatch({
      type: actions.LOAD_RECORDS,
      data: fromJS(json)
    })
  })
  .catch(logErrorConsole)
};

export const loadRecordsByStaff = (id, limit, offset) => (dispatch, getState) => {
  dispatch(recordIsLoading(true));
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  fetch(`${config.apiHost}/record/?administration=${id}&limit=${limit}&offset=${offset}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    dispatch(recordIsLoading(false))
    dispatch({
      type: actions.LOAD_RECORDS,
      data: fromJS(json)
    })
  })
  .catch(logErrorConsole)
};

export const loadRecordDetail = (id) => (dispatch, getState) => {
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  dispatch(recordIsLoading(true));
  fetch(`${config.apiHost}/record/${id}/`, options)
  .then(checkJsonResponse)
  .then((json) => {
    dispatch(recordIsLoading(false));
    dispatch({
      type: actions.LOAD_RECORD_DETAIL,
      data: fromJS(json)
    })
  })
  .catch(logErrorConsole)
};

export const changeDate = (data) => ({
  type: actions.CHANGE_DATE,
  data
});

export const loadReceptionByDate = (date, id) => (dispatch, getState) => {
  const date_record = date.format("YYYY-MM-DD");
  fetch(`${config.apiHost}/reception/?start_date=${date_record}&staff=${id}`)
  .then(checkJsonResponse)
  .then((json) => {
    dispatch({
      type: actions.LOAD_RECEPTION,
      data: fromJS(json.results)
    })
  })
  .catch(logErrorConsole)
};

export const updateRecord = (record_id, reception_id, user_id, status, comment) => (dispatch, getState) => {
  const options = {
    method : "put",
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
      "Content-type": 'application/json'
    },
    body: JSON.stringify({
      reception: reception_id,
      user:   user_id,
      status: status,
      comment: comment
    })
  }
  fetch(`${config.apiHost}/record/${record_id}/`, options)
  .then(checkJsonResponse)
  .then((json) => {
    dispatch(loadRecordDetail(record_id))
  })
  .catch(logErrorConsole)
}



// WEBPACK FOOTER //
// ./src/redux/actions/portal/records.js